import * as React from 'react';
import isEmpty from 'lodash/isEmpty';
import { Context } from '@grandvisionhq/carts-v2';
import { toast } from '@grandvisionhq/common';
import { useLink } from '@grandvisionhq/frk-routing';
import { useSync } from '@grandvisionhq/lib-utils-w3c';
import { useIntl, useSelector, useDispatch } from '@grandvisionhq/state';
import { updateCartState } from '../actions.js';
import { useCheckoutSettings } from '../context/CheckoutSettings/context.js';
import '@swc/helpers';
import '@grandvisionhq/graphql';
import '@grandvisionhq/payments';
import '@grandvisionhq/utils';
import '@grandvisionhq/api-client';
import { useSyncCartShippingMethodWithReduxAfterTabFocus } from '../hooks/carts/use-sync-cart-shipping-method-with-redux.js';
import '@grandvisionhq/auth';
import { getServiceStore } from '../selectors.js';
import { useSetCustomerDetails } from '../hooks/operations/use-set-customer-details.js';
import '@grandvisionhq/lib-utils-cart';
import '../mappers/errors-mapping.js';
import '../operations/mutations/set-customer-details.js';
import '../operations/mutations/set-shipping-method.js';
import '../operations/mutations/set-shipping-state.js';
import '../operations/mutations/set-store.js';
import '../operations/mutations/create-apple-pay-session.js';
import '../operations/mutations/recreate-ordered-checkout.js';
import '../utils/get-customer-details-payload.js';
import { isPickupStore, isPickupPoint } from '../utils/shipping-method.js';
import 'history';
import '../models/cart/cart-state.js';
import { CheckoutStepErrorType } from '../models/checkout/checkout-step-error-type.js';
import '../models/checkout-settings.js';
import '../models/step-shipping/shipping-methods.js';
import '../models/shared.js';
import '../utils/has-cart-errors.js';
import '@grandvisionhq/fun-orders';
import '@grandvisionhq/analytics';
import '../operations/fragments/checkout-mutation-result.js';
import '../operations/fragments/cart-mutation-failures.js';
import '../operations/fragments/recreate-ordered-checkout-failure.js';
import '../operations/fragments/recreate-ordered-checkout-result.js';
import '../operations/fragments/paypal-payment.js';
import '../operations/fragments/saved-user-details.js';
import '../operations/queries/get-checkout-state.js';
import '../operations/queries/get-user-details.js';
import { selectStore, selectServiceStore, selectPickupPoint } from '../StepShipping/actions.js';
import { useShippingMethodSelection } from '../StepShipping/modules/ShippingMethods/hooks/use-shipping-method-selection.js';
import { useShippingMethodsList } from '../StepShipping/modules/ShippingMethods/hooks/use-shipping-methods-list.js';
import { shippingMethodsFailed } from '../StepShipping/modules/ShippingMethods/state/actions.js';
import { isShippingStepValid, getSelectedShippingMethod, shouldValidateServiceStore, getSelectedStore, getSelectedPickupPoint } from '../StepShipping/selectors.js';
import { usePrepareCustomerDetails } from './hooks/use-prepare-customer-details.js';
import { StepOverview } from './StepOverview.js';

const StepOverviewContainer = (props)=>{
    var ref3, ref1;
    const { onNextStep , onPrevStep , shippingMethodsAsides  } = props;
    const { getLabel  } = useIntl();
    const { customerDetails  } = usePrepareCustomerDetails();
    const isShippingStepValid$1 = useSelector(isShippingStepValid);
    const serviceStore1 = useSelector(getServiceStore);
    const { serviceStore: serviceStoreOptions , features  } = useCheckoutSettings();
    const { cart  } = Context.useCart();
    const selectedShippingMethod = (ref3 = useSelector(getSelectedShippingMethod)) === null || ref3 === void 0 ? void 0 : ref3.method;
    const isPickupStore$1 = isPickupStore(selectedShippingMethod);
    const validateServiceStore = useSelector(shouldValidateServiceStore);
    const { onClick: navigateToCart  } = useLink({
        route: 'cart.overview'
    }, {
        replace: true
    }) || {};
    const broadCastChannel = useSync('new-cart-created').getChannel();
    const dispatch = useDispatch();
    broadCastChannel.onmessage = ()=>{
        toast.failed('cart.errors.cartNotInActiveState');
        navigateToCart === null || navigateToCart === void 0 ? void 0 : navigateToCart();
    };
    const isOverviewStepValid = React.useCallback(()=>{
        var ref;
        if (validateServiceStore && (features === null || features === void 0 ? void 0 : features.isServiceStoreEnabled) && !isPickupStore$1 && !serviceStore1) {
            return false;
        }
        var ref2;
        if (!((ref2 = serviceStoreOptions === null || serviceStoreOptions === void 0 ? void 0 : serviceStoreOptions.isOptional) !== null && ref2 !== void 0 ? ref2 : true) && !(cart === null || cart === void 0 ? void 0 : (ref = cart.serviceStore) === null || ref === void 0 ? void 0 : ref.code)) {
            return false;
        }
        return isShippingStepValid$1;
    }, [
        validateServiceStore,
        features === null || features === void 0 ? void 0 : features.isServiceStoreEnabled,
        isPickupStore$1,
        serviceStore1,
        serviceStoreOptions === null || serviceStoreOptions === void 0 ? void 0 : serviceStoreOptions.isOptional,
        cart === null || cart === void 0 ? void 0 : (ref1 = cart.serviceStore) === null || ref1 === void 0 ? void 0 : ref1.code,
        isShippingStepValid$1, 
    ]);
    const onShippingMethodLoadError = React.useCallback(()=>{
        dispatch(shippingMethodsFailed({
            message: 'Unable to load shipping methods'
        }));
    }, [
        dispatch
    ]);
    const { shippingMethodList , reloadShippingMethods  } = useShippingMethodsList(()=>{}, onShippingMethodLoadError);
    const onError = React.useCallback(()=>{
        reloadShippingMethods();
    }, [
        reloadShippingMethods
    ]);
    const { handleOnShippingMethodSelected  } = useShippingMethodSelection({
        shippingMethodList,
        onError
    });
    React.useEffect(()=>{
        if (!isOverviewStepValid()) {
            onPrevStep(CheckoutStepErrorType.ShippingStepFailed);
        }
    // Need to check validity of overview step and redirect user to shipping step
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onCompleted = React.useCallback((operation)=>{
        (cart === null || cart === void 0 ? void 0 : cart.checkoutState) && dispatch(updateCartState({
            cartState: cart === null || cart === void 0 ? void 0 : cart.checkoutState
        }));
        // The payment page needs the fresh cart data.
        // If we want to ditch redux, everything should rely on apollo
        operation === 'MUTATION' && onNextStep();
    }, [
        cart === null || cart === void 0 ? void 0 : cart.checkoutState,
        dispatch,
        onNextStep
    ]);
    const { setCustomerDetails  } = useSetCustomerDetails({
        onCompleted,
        onError: ()=>{
            toast.failed('checkout.errors.form.general');
        }
    });
    useSyncCartShippingMethodWithReduxAfterTabFocus();
    const onNextClick = ()=>{
        if (!isOverviewStepValid()) {
            onPrevStep();
        } else if (customerDetails && !isEmpty(customerDetails)) {
            setCustomerDetails(customerDetails);
        }
    };
    const selectedStore = useSelector(getSelectedStore);
    const selectedPickupPoint = useSelector(getSelectedPickupPoint);
    const isPickupPoint$1 = isPickupPoint(selectedShippingMethod);
    const onStoreSelect = (store)=>{
        const serviceStore = {
            code: store.code,
            name: store.name,
            streetName: store.streetName,
            streetNumber: store.streetNumber,
            town: store.town
        };
        dispatch(selectStore({
            store
        }));
        dispatch(selectServiceStore({
            serviceStore
        }));
    };
    const onPickupPointSelect = (pickupPoint)=>{
        if (!pickupPoint) {
            return;
        }
        dispatch(selectPickupPoint({
            pickupPoint
        }));
    };
    const labels = React.useMemo(()=>({
            generic: {
                title: getLabel('checkout.generic.title'),
                deliveryAddress: getLabel('checkout.deliveryAddress')
            },
            yourDetails: getLabel('checkout.yourDetails'),
            billingAddress: getLabel('checkout.billingAddress'),
            completed: {
                shipmentDetailsDelivery: getLabel('checkout.completed.shipmentDetails.delivery')
            },
            contactTitle: getLabel('checkout.contact.title'),
            customerTypeCompany: getLabel('checkout.customerType.company'),
            serviceStoreTitle: getLabel('checkout.serviceStore.title'),
            shipmentAddress: getLabel('checkout.shipment.address'),
            summary: {
                delivery: getLabel('checkout.summary.shipment.delivery'),
                deliveryExpress: getLabel('checkout.summary.shipment.deliveryExpress'),
                pickupStore: getLabel('checkout.summary.shipment.pickup'),
                pickupPoint: getLabel('checkout.summary.shipment.pickupPoint'),
                nearestPickup: getLabel('checkout.summary.shipment.nearestPickup'),
                address: getLabel('checkout.summary.shipment.address'),
                deliveryPremium: getLabel('checkout.summary.shipment.deliveryPremium'),
                deliveryResponsible: getLabel('checkout.summary.shipment.deliveryResponsible')
            },
            editModal: {
                save: getLabel('common.actions.save')
            },
            differentDeliveryAddress: getLabel('checkout.shipment.differentDeliveryAddress'),
            nearestPickupMessage: getLabel('checkout.summary.shipment.nearestPickup.message')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(StepOverview, {
        cartComponent: props.cartComponent,
        isPickupPoint: isPickupPoint$1,
        isPickupStore: isPickupStore$1,
        labels: labels,
        onEdit: onPrevStep,
        onNextClick: onNextClick,
        onPrevClick: onPrevStep,
        selectedPickupPoint: selectedPickupPoint,
        selectedStore: selectedStore,
        serviceStore: serviceStore1,
        shippingMethod: selectedShippingMethod,
        shippingMethodsAsides: shippingMethodsAsides,
        onPickupPointSelect: onPickupPointSelect,
        onStoreSelect: onStoreSelect,
        shippingMethodList: shippingMethodList,
        handleOnShippingMethodSelected: handleOnShippingMethodSelected
    });
};

export { StepOverviewContainer };
//# sourceMappingURL=StepOverviewContainer.js.map
